import React, { useState, FunctionComponent } from "react";
import styles from "./LanguageSelector.module.scss";
import LanguageSelectorProps from "./LanguageSelectorProps.interface";

import getCulturesList from "./helpers/getCulturesList";
import getCurrentLanguage from "./helpers/getCurrentLanguage";

import { useSelector } from "react-redux";
import Anchor from "components/Anchor/Anchor";
import IconViewer from "components/IconViewer/IconViewer";
import useClickOutside from "layout/hooks/useClickOutside";

const LanguageSelector: FunctionComponent<LanguageSelectorProps> = (props) => {
    const wrapperElementRef = useClickOutside(() => setIsToggled(false));

    const translations = useSelector((state) => state.dictionary.translations);

    const [isToggled, setIsToggled] = useState(false);

    const page = useSelector((state) => state.page.content);

    if (!page || typeof page._cultures === "undefined" || typeof page._culture === "undefined") {
        return null;
    }

    const cultures = getCulturesList(page._cultures, translations);
    const currentLanguage = getCurrentLanguage(page._culture, cultures);

    return (
        <div
            className={styles.wrapper}
            ref={wrapperElementRef}
        >
            {/* Button */}
            <button
                className={styles.button}
                onClick={() => setIsToggled(!isToggled)}
            >
                <IconViewer
                    className={styles.button_icon}
                    name="globe"
                />
                {currentLanguage.label}
                <IconViewer
                    className={styles.button_chevron}
                    name="chevron-down"
                />
            </button>

            {/* Dropdown */}
            {isToggled === true ? (
                <div className={styles.list}>
                    {cultures?.map((culture: any, index: number) => (
                        <span
                            key={index}
                            onClick={() => setIsToggled(!isToggled)}
                        >
                            {/* TODO: Use Redux to show dropdown */}
                            <Anchor
                                className={styles.item}
                                to={culture?.link}
                            >
                                {culture?.label}
                            </Anchor>
                        </span>
                    ))}

                    <button
                        className={styles.current_item}
                        onClick={() => setIsToggled(false)}
                    >
                        <IconViewer
                            className={styles.button_icon}
                            name="globe"
                        />
                        {currentLanguage.label}
                        <IconViewer
                            className={styles.button_chevron}
                            name="chevron-up"
                        />
                    </button>
                </div>
            ) : null}
        </div>
    );
};

export default LanguageSelector;
